<template>
  <div v-if="value" class="form-list">
    <section class="form-list__tags">
      <FormListItem
        v-for="(item, index) in value"
        :key="index"
        :value="item"
        :index="index"
        :remove-item="removeItem"
        :readonly="readonly"
        :removable="removable"
        :color="color"
      />
    </section>
    <FormListNewItem
      v-if="removable"
      :add-item="addItem"
      :readonly="readonly"
      :autocomplete="autocomplete"
      :check-role="checkRole"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

import FormListItem from './FormListItem.vue'
import FormListNewItem from './FormListNewItem.vue'

export default {
  name: 'FormList',
  components: {
    FormListItem,
    FormListNewItem
  },
  props: {
    removable: { type: Boolean, default: true },
    value: { type: Array, default: undefined },
    placeholder: { type: String, default: undefined },
    autocomplete: Boolean,
    readonly: Boolean,
    checkRole: {
      default: true,
      type: Boolean
    },
    color: {
      type: String,
      default: 'blue'
    }
  },
  emits: ['input', 'add', 'remove'],
  methods: {
    addItem({ value, type = 'FREE_TEXT', description, name }) {
      if (value || name) {
        const items = cloneDeep(this.value)
        const newItem = { value, type, description, name }
        if (!items.find(i => i.value === value)) {
          items.push(newItem)
          this.$emit('input', items)
          this.$emit('add', newItem)
        }
      }
    },
    removeItem(index) {
      const items = cloneDeep(this.value)
      items.splice(index, 1)
      this.$emit('input', items)
      this.$emit('remove', this.value[index])
    }
  }
}
</script>

<style lang="scss">
.form-list {
  position: relative;

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gl-spacing-02);
    margin: var(--gl-spacing-03) 0;
  }
}
</style>
